export const ORG_TYPES = {
  EDUCATION: 'education',
  FITNESS: 'fitness',
};

export const USER_ROLES = {
  ADMIN: 'admin',
  ADMIN_VIEWER: 'admin_viewer',
  TEACHER: 'teacher',
  STUDENT: 'student',
  TRAINER: 'trainer',
  MEMBER: 'member',
};

export const AUTH_URLS = {
  EMAIL_LOGIN: 'user/auth/empass/',
  GOOGLE_LOGIN: 'user/auth/google/',
  REFRESH_TOKEN: 'user/token/refresh/',
  EXPIRE_TOKEN: 'user/logout/',
};

export const SEND_INVITE_URL = 'user/send-invite/';

export const UPDATE_FEE_URL = 'fees/fee-installment/';

export const NOTIFICATION_TIMEOUT = {
  error: 3000,
  warning: 3000,
  info: 5000,
  success: 1000,
};
export const API_ERROR_MESSAGE = {
  clientError: 'Please check your input.',
  clientError429: 'Too Many Requests: Please try again later!!!',
  serverError: 'Something went wrong. Please hang on while we fix this for you.',
  error: 'Something went wrong here. Please hang on while we fix this for you.',
  networkError: 'Network error. Please try again later.',
};

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong. Please try again. If the issue persists, contact support.';

export const PRODUCT_NAME = 'ClassChronicle';
export const WEBSITE_NAME = 'classchronicle.com';
export const WEBSITE_LINK = 'https://classchronicle.com/';
export const SUPPORT_EMAIL = 'support@classchronicle.com';

export const YOUTUBE_CHANNEL_LINK = "https://www.youtube.com/@ClassChronicleApp"
export const YOUTUBE_VIDEO_ID = "H3UGafahUhA";  // Getting Started Video - H3UGafahUhA

export const URL_PARAMS = {
  SCHEDULE_ID: 'tt',
  // VIEW_TYPE: 'vt',
  // VIEW_ELEMENT: 've',
  STEP: 'st',
};

// TimeTable Polling Config
export const TT_POLL_INTERVAL_INITIAL = 30 * 1000;  // 30 Seconds -> 20 * 1000
export const TT_POLL_INTERVAL_FINAL = 3 * 60 * 1000;  // 3 Minutes -> 3 * 60 * 1000
export const TT_POLL_QUICK_CUTOFF = 2 * 60 * 1000;  // 2 Minutes -> 2 * 60 * 1000

export const TT_BG_COLOR = {
  HEADER: '#F5F5F5',
  CELL: '#FFFFFF',
  RESERVED: '#FFFFFF',
  BREAK: '#F5F5F5',
  CONFLICT: '#FF6961',
};

export const NA_LABEL = "(Not Available)";

// Billing
export const ORIGINAL_SUBSCRIPTION_PRICE = 4999;  // 9 * 12 * 1.18 * 50 = 6372/-
export const FINAL_SUBSCRIPTION_PRICE = 3999;
